var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-layer"},[(!_vm.isStudent)?_c('fruit-order'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }